<template>
  <div>
    <!-- Video.js プレーヤー -->
    <video ref="videoPlayer" class="video-js vjs-default-skin"></video>

    <div class="vjs-skip-controls d-flex align-items-center justify-content-center flex-nowrap mt-2">
      <div class="btn-group mr-2" role="group" aria-label="Backward seek">
        <button
          v-for="step in SEEK_STEPS_DESC"
          :key="`back-${step}`"
          type="button"
          class="btn btn-sm skip-btn mr-1"
          @click="seek(step, 'backward')"
        >
          <i class="fas fa-angle-double-left"></i> {{ step }}
        </button>
      </div>

      <div class="btn-group ml-2" role="group" aria-label="Forward seek">
        <button
          v-for="step in SEEK_STEPS"
          :key="`forward-${step}`"
          type="button"
          class="btn btn-sm skip-btn mr-1"
          @click="seek(step, 'forward')"
        >
          {{ step }} <i class="fas fa-angle-double-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

const PLAYBACK_RATES = [0.5, 1, 1.5, 2, 4, 8]
const SEEK_STEPS = [3, 10, 30, 60]
const SEEK_STEPS_DESC = [...SEEK_STEPS].reverse()

const props = defineProps({
  poster: String,
  src: String
})

const player = ref(null)
const videoPlayer = ref(null)

const audioTracks = ref([])        // 音声トラック一覧 [{label, index}]
const selectedTrackIndex = ref(-1) // 選択中のトラックインデックス

onMounted(() => {
  player.value = videojs(videoPlayer.value, {
    poster: props.poster,
    autoplay: false,
    controls: true,
    fluid: true,
    playbackRates: PLAYBACK_RATES,
    sources: [{
      src: props.src,
      type: 'application/x-mpegURL'
    }],
    html5: {
      vhs: {
        withCredentials: true
      }
    }
  })

  player.value.on('loadedmetadata', () => {
    const vjsTracks = player.value.audioTracks()
    console.log('audioTracks:', vjsTracks, vjsTracks.length)
    audioTracks.value = []
    for (let i = 0; i < vjsTracks.length; i++) {
      audioTracks.value.push({
        label: vjsTracks[i].label || `Track ${i + 1}`,
        index: i
      })
    }
    console.log('audioTracks.value:', audioTracks.value)

    vjsTracks.addEventListener('change', () => {
      for (let i = 0; i < vjsTracks.length; i++) {
        if (vjsTracks[i].enabled) {
          selectedTrackIndex.value = i
        }
      }
    })
  })
})

function changeAudioTrack() {
  const vjsTracks = player.value.audioTracks()
  for (let i = 0; i < vjsTracks.length; i++) {
    vjsTracks[i].enabled = (i === selectedTrackIndex.value)
  }
}

onBeforeUnmount(() => {
  if (player.value) {
    player.value.dispose()
  }
})

function seek(step, direction) {
  if (!player.value) return
  const current = player.value.currentTime()
  const next = direction === 'backward' ? Math.max(0, current - step) : current + step
  player.value.currentTime(next)
}
</script>
